import { INotification, INotificationBody } from 'src/types';
import BaseService from './base.service';

export default class NotificationService extends BaseService<INotification, INotificationBody, INotificationBody> {
  constructor() {
    super('/notifications');
  }
}
